export var STATUS = {
  CHECKING: 0,
  CHECK_SUCCESS: 1,
  CHECK_FAIL: 2
};
export default {};